var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargerInstallation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.282,
    height: 30.815,
    viewBox: "0 0 32.282 30.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Charger_Installation",
    "data-name": "Charger Installation",
    transform: "translate(-390.089 -457.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    transform: "translate(390.089 457.964)",
    fill: "none",
    stroke: "#00b26b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.282,
    height: 30.815,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31.282,
    height: 29.815,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-wallbox-6696476",
    transform: "translate(373.003 451.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(27.687 12.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M37.773,12.539H28.657a.96.96,0,0,0-.97.97V23.4a.96.96,0,0,0,.97.97h9.116a.96.96,0,0,0,.97-.97V13.509A.96.96,0,0,0,37.773,12.539Zm-4.546,8.414a2.59,2.59,0,1,1,2.591-2.591A2.591,2.591,0,0,1,33.226,20.953Z",
    transform: "translate(-27.687 -12.539)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M46.517,32.891l.283-1.53h-.683l1.53-2-.283,1.53h.683Z",
    transform: "translate(-41.542 -25.183)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M43.106,67.094h-1v-.7h1a.351.351,0,1,0,0-.7h-1v-.353h-1.73a.64.64,0,0,0-.65.65v.559h-.813a.377.377,0,0,1-.376-.376V64.5a.958.958,0,1,0-1.916,0v2.667a.377.377,0,0,1-.376.376h-.07a.377.377,0,0,1-.376-.376V62.743h.656a.572.572,0,0,0,.582-.582v-.388h-3.1v.388a.572.572,0,0,0,.582.582h.7v4.426a.96.96,0,0,0,.958.958h.07a.959.959,0,0,0,.958-.958V64.5a.376.376,0,1,1,.753,0v1.664a.959.959,0,0,0,.958.958h.813V67.5a.64.64,0,0,0,.65.65H42.1V67.8h1a.351.351,0,1,0,0-.7Z",
    transform: "translate(-32.38 -49.55)",
    fill: "#00b26b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargerInstallation);
export default __webpack_public_path__ + "static/media/Charger Installation.59442da1091a129d126d13765ca0a362.svg";
export { ForwardRef as ReactComponent };